import React from 'react';

export const SurveyCompletedCover = () => {
  return (
    <svg
      width="220"
      height="142"
      viewBox="0 0 220 142"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g filter="url(#filter0_f_10785_6626)">
        <rect
          x="74.3867"
          y="48.7188"
          width="71.2259"
          height="71.2259"
          rx="35.6129"
          fill="#99BCFF"
          fillOpacity="0.5"
        />
      </g>
      <g filter="url(#filter1_f_10785_6626)">
        <rect
          x="74.3867"
          y="42.3909"
          width="71.2259"
          height="71.2259"
          rx="35.6129"
          fill="white"
        />
      </g>
      <foreignObject x="70.2685" y="36.1631" width="79.4629" height="79.4622">
        <div
          style={{
            backdropFilter: 'blur(2.06px)',
            clipPath: 'url(#bgblur_0_10785_6626_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <rect
        data-figma-bg-blur-radius="4.11819"
        x="74.3867"
        y="40.2812"
        width="71.2259"
        height="71.2259"
        rx="35.6129"
        fill="url(#paint0_linear_10785_6626)"
        fillOpacity="0.9"
      />
      <foreignObject x="69.1733" y="30.8491" width="81.6533" height="81.6526">
        <div
          style={{
            backdropFilter: 'blur(2.61px)',
            clipPath: 'url(#bgblur_1_10785_6626_clip_path)',
            height: '100%',
            width: '100%',
          }}
        ></div>
      </foreignObject>
      <g
        filter="url(#filter3_i_10785_6626)"
        data-figma-bg-blur-radius="5.21337"
      >
        <rect
          x="74.3867"
          y="36.0625"
          width="71.2259"
          height="71.2259"
          rx="35.6129"
          fill="url(#paint1_linear_10785_6626)"
          fillOpacity="0.9"
        />
        <g
          clipPath="url(#paint2_diamond_10785_6626_clip_path)"
          data-figma-skip-parse="true"
        >
          <g transform="matrix(-0.0281045 0.0723711 -0.0723711 -0.135969 96.3852 58.5809)">
            <rect
              x="0"
              y="0"
              width="966.127"
              height="567.223"
              fill="url(#paint2_diamond_10785_6626)"
              opacity="0.6"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="966.127"
              height="567.223"
              transform="scale(1 -1)"
              fill="url(#paint2_diamond_10785_6626)"
              opacity="0.6"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="966.127"
              height="567.223"
              transform="scale(-1 1)"
              fill="url(#paint2_diamond_10785_6626)"
              opacity="0.6"
              shapeRendering="crispEdges"
            />
            <rect
              x="0"
              y="0"
              width="966.127"
              height="567.223"
              transform="scale(-1)"
              fill="url(#paint2_diamond_10785_6626)"
              opacity="0.6"
              shapeRendering="crispEdges"
            />
          </g>
        </g>
        <rect
          x="74.3867"
          y="36.0625"
          width="71.2259"
          height="71.2259"
          rx="35.6129"
          data-figma-gradient-fill="{&#34;type&#34;:&#34;GRADIENT_DIAMOND&#34;,&#34;stops&#34;:[{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:1.0},&#34;position&#34;:0.0},{&#34;color&#34;:{&#34;r&#34;:1.0,&#34;g&#34;:1.0,&#34;b&#34;:1.0,&#34;a&#34;:0.0},&#34;position&#34;:1.0}],&#34;stopsVar&#34;:[],&#34;transform&#34;:{&#34;m00&#34;:-56.2089843750,&#34;m01&#34;:-144.74220275878906,&#34;m02&#34;:196.86079406738281,&#34;m10&#34;:144.74220275878906,&#34;m11&#34;:-271.93801879882812,&#34;m12&#34;:122.17875671386719},&#34;opacity&#34;:0.60000002384185791,&#34;blendMode&#34;:&#34;NORMAL&#34;,&#34;visible&#34;:true}"
        />
        <rect
          x="75.4163"
          y="37.092"
          width="69.1668"
          height="69.1668"
          rx="34.5834"
          stroke="white"
          strokeOpacity="0.3"
          strokeWidth="2.05909"
        />
      </g>
      <g filter="url(#filter4_d_10785_6626)">
        <path
          d="M107.028 79.065L98.5004 70.5373C97.8712 69.9081 96.8511 69.9081 96.2219 70.5373C95.5927 71.1665 95.5927 72.1866 96.2219 72.8158L105.889 82.4828C106.518 83.112 107.538 83.112 108.167 82.4828L127.501 63.1489C128.131 62.5197 128.131 61.4995 127.501 60.8703C126.872 60.2411 125.852 60.2411 125.223 60.8703L107.028 79.065Z"
          fill="white"
        />
        <path
          d="M124.841 60.4893C125.681 59.6493 127.043 59.6493 127.883 60.4893C128.723 61.3292 128.723 62.6904 127.883 63.5303L108.549 82.8643C107.709 83.7042 106.347 83.7042 105.507 82.8643L95.8408 73.1973C95.0009 72.3573 95.0009 70.9952 95.8408 70.1553C96.6807 69.3159 98.042 69.3158 98.8818 70.1553L107.028 78.3018L124.841 60.4893Z"
          stroke="white"
          strokeWidth="1.07918"
        />
      </g>
      <path
        d="M1.97142 67.662C2.34458 67.2351 2.75207 66.8549 3.17508 66.5086C5.2859 64.7383 7.74746 64.2095 9.45177 65.1704C11.2407 66.001 12.9245 67.1372 14.77 68.2915C17.0138 69.6336 19.5663 71.372 23.0562 71.3502C24.3537 71.3027 25.8475 70.9889 26.9901 70.0182C28.1454 69.0456 28.5345 67.6617 28.5436 66.5142C28.5528 65.9344 28.4841 65.3759 28.372 64.8366C28.2148 65.3728 28.0268 65.8934 27.7933 66.3707C26.8249 68.478 25.1519 68.7874 23.3446 68.3761C21.3069 67.9146 19.3089 66.3586 17.0226 64.9446C15.1546 63.7791 13.0513 62.6254 10.6349 62.0454C7.09646 61.0116 3.66904 63.5437 2.5706 66.0621C2.31191 66.5828 2.10534 67.1197 1.97142 67.662Z"
        fill="#99BCFF"
      />
      <path
        d="M176.948 49.156C176.799 48.6299 176.707 48.1019 176.653 47.5826C176.34 44.9526 177.28 42.7044 179.094 41.9551C180.838 41.059 182.789 40.4206 184.856 39.669C187.31 38.721 190.307 37.7669 192.327 35.0628C193.056 34.019 193.652 32.6523 193.447 31.2154C193.246 29.7725 192.27 28.7141 191.279 28.0543C190.786 27.7225 190.267 27.4592 189.738 27.2387C190.104 27.6639 190.438 28.1032 190.712 28.5522C191.972 30.5035 191.317 32.0048 189.901 33.1661C188.351 34.4534 185.861 35.0957 183.318 36.034C181.228 36.7967 179.002 37.7461 177.088 39.2711C174.059 41.4658 174.372 45.5589 175.913 47.8043C176.214 48.2914 176.559 48.7502 176.948 49.156Z"
        fill="#99BCFF"
      />
      <path
        d="M127.677 23.9007C127.677 23.9007 127.677 23.9007 127.677 23.9007C127.576 23.413 127.613 22.8966 127.644 22.392C128.099 17.8973 129.42 13.7746 131.521 10.3749C133.621 6.97437 136.876 4.31215 141.261 2.37325C141.729 2.15962 142.221 1.95059 142.738 1.74762C142.738 1.74762 142.738 1.74762 142.738 1.74762C142.177 1.69389 141.626 1.66137 141.086 1.64983C136.134 1.46748 130.657 3.89058 127.982 8.33817C125.27 12.7133 125.086 18.0285 126.874 22.4989C127.09 22.9951 127.322 23.5109 127.677 23.9007Z"
        fill="#99BCFF"
      />
      <path
        d="M189.699 115.157C189.519 114.577 189.409 113.993 189.346 113.416C189.028 110.865 189.954 108.631 191.78 107.871C193.663 107.007 196.467 107.003 199.148 107.088C204.44 107.32 209.949 107.939 215.62 108.353C216.23 108.397 216.899 108.456 217.509 108.502C216.976 108.208 216.372 107.912 215.82 107.643C210.656 105.198 205.143 103.466 199.226 103.2C196.212 103.151 192.877 103.224 189.902 105.358C187.009 107.467 187.195 111.375 188.602 113.625C188.914 114.178 189.278 114.697 189.699 115.157Z"
        fill="#99BCFF"
      />
      <path
        d="M15.1998 92.37C15.5323 91.5245 16.7287 91.5245 17.0611 92.37L19.4065 98.3347C19.5132 98.606 19.733 98.8172 20.0083 98.9131L26.17 101.059C27.0649 101.37 27.0649 102.636 26.17 102.948L20.0083 105.093C19.733 105.189 19.5132 105.4 19.4065 105.672L17.0611 111.636C16.7287 112.482 15.5323 112.482 15.1998 111.636L12.8545 105.672C12.7478 105.4 12.528 105.189 12.2527 105.093L6.0909 102.948C5.19604 102.636 5.19604 101.37 6.0909 101.059L12.2527 98.9131C12.528 98.8172 12.7478 98.606 12.8545 98.3347L15.1998 92.37Z"
        fill="#99BCFF"
      />
      <path
        d="M167.63 6.55298C167.796 6.13036 168.394 6.1303 168.561 6.55298L169.758 9.5979C169.918 10.0049 170.247 10.3223 170.66 10.4661L173.72 11.5305C174.167 11.6864 174.167 12.32 173.72 12.4758L170.66 13.5403C170.247 13.6841 169.918 14.0015 169.758 14.4084L168.561 17.4534C168.394 17.876 167.796 17.876 167.63 17.4534L166.432 14.4084C166.272 14.0015 165.942 13.6841 165.529 13.5403L162.47 12.4758C162.023 12.3199 162.023 11.6864 162.47 11.5305L165.529 10.4661C165.942 10.3223 166.272 10.0048 166.432 9.5979L167.63 6.55298Z"
        fill="#99BCFF"
        stroke="#99BCFF"
      />
      <ellipse cx="193.598" cy="74.0032" rx="5.31315" ry="5" fill="#99BCFF" />
      <ellipse cx="97.9616" cy="17.0032" rx="5.31315" ry="5" fill="#99BCFF" />
      <ellipse cx="183.504" cy="67.5032" rx="2.65658" ry="2.5" fill="#99BCFF" />
      <ellipse cx="103.805" cy="8.50317" rx="2.65658" ry="2.5" fill="#99BCFF" />
      <ellipse cx="49.6136" cy="51.5032" rx="2.65658" ry="2.5" fill="#99BCFF" />
      <path
        d="M41.6408 12.0032C41.5384 12.8518 41.4477 13.7072 41.4506 14.5821C41.4399 16.5058 41.9514 18.8239 43.8601 20.1962C46.4678 21.8894 49.3764 22.28 52.3741 21.9681C53.8286 21.7271 55.6355 21.3918 56.844 19.4903C57.9754 17.3886 56.9622 15.4309 56.1771 14.1835C55.9324 13.8097 55.6971 13.4973 55.3642 13.1508C54.7046 12.4484 53.5969 11.7642 52.3533 11.7894C51.1215 11.8065 50.1617 12.368 49.4484 12.9442C48.0272 14.1383 47.2047 15.5806 46.5604 17.049C45.4707 19.9318 44.378 23.5437 46.9154 26.5405C48.6173 27.9751 50.5512 28.0613 52.3443 28.1399C53.2114 28.1533 54.0782 28.1111 54.9237 28.0032C54.9237 28.0032 54.9237 28.0032 54.9237 28.0032C54.0778 27.9111 53.2336 27.7632 52.4131 27.5741C50.738 27.1769 48.9261 26.568 48.0551 25.4659C46.8211 23.6013 47.7717 20.4644 48.9493 18.1764C49.5656 17.0099 50.3728 15.8875 51.2499 15.23C51.6832 14.9021 52.1052 14.7521 52.3571 14.767C52.6012 14.7744 52.8648 14.8868 53.2101 15.2387C53.3716 15.4067 53.512 15.5851 53.6703 15.8228C57.2349 19.4928 48.6146 20.6235 44.7347 18.8101C43.2725 18.1145 42.395 16.3681 42.0174 14.5221C41.839 13.7024 41.7381 12.8535 41.6408 12.0032Z"
        fill="#99BCFF"
      />
      <defs>
        <filter
          id="filter0_f_10785_6626"
          x="52.7662"
          y="27.0983"
          width="114.468"
          height="114.467"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="10.8102"
            result="effect1_foregroundBlur_10785_6626"
          />
        </filter>
        <filter
          id="filter1_f_10785_6626"
          x="66.1503"
          y="34.1545"
          width="87.6993"
          height="87.6986"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="4.11819"
            result="effect1_foregroundBlur_10785_6626"
          />
        </filter>
        <clipPath
          id="bgblur_0_10785_6626_clip_path"
          transform="translate(-70.2685 -36.1631)"
        >
          <rect
            x="74.3867"
            y="40.2812"
            width="71.2259"
            height="71.2259"
            rx="35.6129"
          />
        </clipPath>
        <filter
          id="filter3_i_10785_6626"
          x="69.1733"
          y="30.8491"
          width="81.6533"
          height="81.6526"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="9.1234" />
          <feGaussianBlur stdDeviation="1.30334" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.4 0"
          />
          <feBlend
            mode="normal"
            in2="shape"
            result="effect1_innerShadow_10785_6626"
          />
        </filter>
        <clipPath
          id="bgblur_1_10785_6626_clip_path"
          transform="translate(-69.1733 -30.8491)"
        >
          <rect
            x="74.3867"
            y="36.0625"
            width="71.2259"
            height="71.2259"
            rx="35.6129"
          />
        </clipPath>
        <clipPath id="paint2_diamond_10785_6626_clip_path">
          <rect
            x="74.3867"
            y="36.0625"
            width="71.2259"
            height="71.2259"
            rx="35.6129"
          />
        </clipPath>
        <filter
          id="filter4_d_10785_6626"
          x="90.3552"
          y="59.3193"
          width="43.0123"
          height="33.348"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="4.31672" />
          <feGaussianBlur stdDeviation="2.15836" />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 0.521569 0 0 0 0 0.666667 0 0 0 0 0.94902 0 0 0 0.6 0"
          />
          <feBlend
            mode="normal"
            in2="BackgroundImageFix"
            result="effect1_dropShadow_10785_6626"
          />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="effect1_dropShadow_10785_6626"
            result="shape"
          />
        </filter>
        <linearGradient
          id="paint0_linear_10785_6626"
          x1="78.1059"
          y1="103.332"
          x2="141.343"
          y2="105.026"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99BCFF" />
          <stop offset="0.270833" stopColor="#85AAF2" />
          <stop offset="0.713542" stopColor="#99BCFF" />
          <stop offset="1" stopColor="#85AAF2" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_10785_6626"
          x1="110"
          y1="36.0625"
          x2="110"
          y2="107.288"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#99BCFF" />
          <stop offset="1" stopColor="#85AAF2" />
        </linearGradient>
        <linearGradient
          id="paint2_diamond_10785_6626"
          x1="0"
          y1="0"
          x2="500"
          y2="500"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  );
};
